import RepairState from 'app/enums/RepairState'

export default function(input){

    switch(input){

        case RepairState.PENDING: return 'Open';
        case RepairState.RESOLVED: return 'Gesloten';
        default: return '';
    }
}